import { GraphQLClient as GraphqlRequestClient } from "graphql-request";

import type { GraphQLClient } from "./types";

const defaultHeaders = {
  "Content-Type": "application/json",
};

export const createGraphQLClient = (): GraphQLClient => {
  const clientConfig = {
    fetch: typeof window !== "undefined" ? window.fetch : () => {},
    credentials: "same-origin",
  } as const;
  return {
    async request({ query, variables, headers, graphQLEndpoint }) {
      const client = new GraphqlRequestClient(graphQLEndpoint, clientConfig);

      return client.rawRequest(query.doc, variables, {
        ...defaultHeaders,
        ...headers,
        "EDO-Graphql-Operation-Name": query.operationName,
      });
    },
  };
};
